import { render, staticRenderFns } from "./AgentesHumanos.vue?vue&type=template&id=ec836a4a&scoped=true"
import script from "./AgentesHumanos.vue?vue&type=script&lang=js"
export * from "./AgentesHumanos.vue?vue&type=script&lang=js"
import style0 from "./AgentesHumanos.vue?vue&type=style&index=0&id=ec836a4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec836a4a",
  null
  
)

export default component.exports